var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49688 2.49896H3.33194C2.8719 2.49896 2.49896 2.8719 2.49896 3.33195V9.16285C2.49896 9.6229 2.8719 9.99584 3.33194 9.99584H7.49688C7.95692 9.99584 8.32986 9.6229 8.32986 9.16285V3.33195C8.32986 2.8719 7.95692 2.49896 7.49688 2.49896Z",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6597 2.49896H12.4948C12.0347 2.49896 11.6618 2.8719 11.6618 3.33195V5.83091C11.6618 6.29095 12.0347 6.66389 12.4948 6.66389H16.6597C17.1198 6.66389 17.4927 6.29095 17.4927 5.83091V3.33195C17.4927 2.8719 17.1198 2.49896 16.6597 2.49896Z",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6597 9.99583H12.4948C12.0347 9.99583 11.6618 10.3688 11.6618 10.8288V16.6597C11.6618 17.1198 12.0347 17.4927 12.4948 17.4927H16.6597C17.1198 17.4927 17.4927 17.1198 17.4927 16.6597V10.8288C17.4927 10.3688 17.1198 9.99583 16.6597 9.99583Z",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49688 13.3278H3.33194C2.8719 13.3278 2.49896 13.7007 2.49896 14.1608V16.6597C2.49896 17.1198 2.8719 17.4927 3.33194 17.4927H7.49688C7.95692 17.4927 8.32986 17.1198 8.32986 16.6597V14.1608C8.32986 13.7007 7.95692 13.3278 7.49688 13.3278Z",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/Dash.6e96886b8566a64243cca8efca1bfc02.svg";
export { ForwardRef as ReactComponent };